/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Strategy_Partner_Bitwise_Meta_TitleInputs */

const en_strategy_partner_bitwise_meta_title = /** @type {(inputs: Strategy_Partner_Bitwise_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise | Glider`)
};

const de_strategy_partner_bitwise_meta_title = /** @type {(inputs: Strategy_Partner_Bitwise_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise | Glider`)
};

const pt_br2_strategy_partner_bitwise_meta_title = /** @type {(inputs: Strategy_Partner_Bitwise_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise | Glider`)
};

const tr_strategy_partner_bitwise_meta_title = /** @type {(inputs: Strategy_Partner_Bitwise_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise | Glider`)
};

const zh_cn2_strategy_partner_bitwise_meta_title = /** @type {(inputs: Strategy_Partner_Bitwise_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise | Glider`)
};

const zh_hk2_strategy_partner_bitwise_meta_title = /** @type {(inputs: Strategy_Partner_Bitwise_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise | Glider`)
};

const ko_kr2_strategy_partner_bitwise_meta_title = /** @type {(inputs: Strategy_Partner_Bitwise_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise | Glider`)
};

const ru_ru2_strategy_partner_bitwise_meta_title = /** @type {(inputs: Strategy_Partner_Bitwise_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise | Glider`)
};

const es_419_strategy_partner_bitwise_meta_title = /** @type {(inputs: Strategy_Partner_Bitwise_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitwise | Glider`)
};

/**
* | output |
* | --- |
* | "Bitwise \| Glider" |
*
* @param {Strategy_Partner_Bitwise_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const strategy_partner_bitwise_meta_title = /** @type {((inputs?: Strategy_Partner_Bitwise_Meta_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Strategy_Partner_Bitwise_Meta_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_strategy_partner_bitwise_meta_title(inputs)
	if (locale === "de") return de_strategy_partner_bitwise_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_strategy_partner_bitwise_meta_title(inputs)
	if (locale === "tr") return tr_strategy_partner_bitwise_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_strategy_partner_bitwise_meta_title(inputs)
	if (locale === "zh-HK") return zh_hk2_strategy_partner_bitwise_meta_title(inputs)
	if (locale === "ko-KR") return ko_kr2_strategy_partner_bitwise_meta_title(inputs)
	if (locale === "ru-RU") return ru_ru2_strategy_partner_bitwise_meta_title(inputs)
	return es_419_strategy_partner_bitwise_meta_title(inputs)
});